module.exports = __webpack_public_path__ + "static/4_2_recommendation_EL-dddbfddd9eb62c5e1f40e1e67178af43.svg";